// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-normal[data-v-203bdb89] {\n  font-size: 16px;\n  font-weight: 300;\n  width: 100%;\n  word-break: break-all;\n  white-space: pre-wrap;\n}\n", ""]);
// Exports
module.exports = exports;
